import { gql } from '@apollo/client';
import {
  SH_STRUCTURE_FRAGMENT,
  SH_STRUCTURE_BASE_FRAGMENT,
  SH_STRUCTURE_INSTRUCTORS_FRAGMENT,
  ERROR_FRAGMENT,
} from './fragments.js';

export const GET_SH_ACCESS_SCOPE = gql`
  query GetShAccessScope {
    MDB {
      id
      _SH_ {
        id
        accessScope {
          structureId
          sportTypes
          sportHubDataExportEnabled
          sportHubPayEnabled
          sportHubMovementsEnabled
          sportHubShopEnabled
          sportHubClubEnabled
          sportHubWebEnabled
        }
      }
    }
  }
`;

export const GET_SH_STRUCTURES = gql`
  query GetShStructures {
    MDB {
      id
      _SH_ {
        id
        structures {
          ...ShStructureBaseFields
          ...ShStructureInstructorsFields
        }
      }
    }
  }
  ${SH_STRUCTURE_BASE_FRAGMENT}
  ${SH_STRUCTURE_INSTRUCTORS_FRAGMENT}
`;

export const SAVE_SH_STRUCTURE = gql`
  mutation SaveShStructure($input: _SH_StructureInput!) {
    _SH_saveStructure(input: $input) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const ADD_SH_STRUCTURE_COLLABORATOR = gql`
  mutation AddShStructureCollaborator($structureId: ID!, $input: _SH_StructureCollaboratorInput!) {
    _SH_addStructureCollaborator(structureId: $structureId, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const REMOVE_SH_STRUCTURE_COLLABORATOR = gql`
  mutation RemoveShStructureCollaborator($structureId: ID!, $collaboratorId: ID!) {
    _SH_removeStructureCollaborator(structureId: $structureId, collaboratorId: $collaboratorId) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const UPDATE_SH_STRUCTURE_COLLABORATOR_PERMISSIONS = gql`
  mutation UpdateShStructureCollaboratorPermissions(
    $structureId: ID!
    $collaboratorId: ID!
    $sportTypes: [String!]
    $modulesEnabledToAccess: [String!]
    $permissionsEnabledToAccess: [String!]
  ) {
    _SH_updateStructureCollaboratorPermissions(
      structureId: $structureId
      collaboratorId: $collaboratorId
      sportTypes: $sportTypes
      modulesEnabledToAccess: $modulesEnabledToAccess
      permissionsEnabledToAccess: $permissionsEnabledToAccess
    ) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const GENERATE_SH_STRUCTURE_COLLABORATOR_ACCESS = gql`
  mutation GenerateShStructureCollaboratorAccess(
    $structureId: ID!
    $collaboratorId: ID!
    $durationInHours: Int
  ) {
    _SH_generateStructureCollaboratorAccess(
      structureId: $structureId
      collaboratorId: $collaboratorId
      durationInHours: $durationInHours
    ) {
      ok
      token
      refreshToken
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const ADD_SH_STRUCTURE_INSTRUCTOR = gql`
  mutation AddShStructureInstructor($structureId: ID!, $input: _SH_StructureInstructorInput!) {
    _SH_addStructureInstructor(structureId: $structureId, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const REMOVE_SH_STRUCTURE_INSTRUCTOR = gql`
  mutation RemoveShStructureInstructor($structureId: ID!, $instructorId: ID!) {
    _SH_removeStructureInstructor(structureId: $structureId, instructorId: $instructorId) {
      ok
      error {
        ...ErrorFields
      }
      structure {
        ...ShStructureFields
      }
    }
  }
  ${SH_STRUCTURE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;
